module.exports = __webpack_public_path__ + "media/app_stores/play_store2x-fb3e9717.png";